import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

const bodyFont = 'Inter, "SVN-Gilroy", Arial, sans-serif';

export const ErrorMatchStyle = {
  wrapper: css`
    position: relative;
    overflow: hidden;
    z-index: 2;

    .state-disabled-content {
      opacity: 0.28;
      filter: grayscale(0.2);
      pointer-events: none;
    }

    .state-overlay {
      position: absolute;
      inset: 0;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: rgba(5, 8, 12, 0.42);
      backdrop-filter: blur(1px);
      pointer-events: all;
    }

    .state-message {
      position: relative;
      z-index: 2;
      max-width: 220px;
      margin: auto;
      color: ${theme.colors.white};
      font-family: ${bodyFont} !important;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.4;
      text-align: center;
      text-shadow: 0 6px 12px rgba(0, 0, 0, 0.35);
    }

    ${media.md} {
      .state-message {
        font-size: 14px;
      }
    }
  `,
};
